import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { photosApi, Photo } from "../api";

interface PhotosState {
  photos: Record<number, Photo>;
  loading: boolean;
}

const initialState: PhotosState = {
  photos: {},
  loading: false,
};

export const fetchPhotos = createAsyncThunk(
  "photos/fetch",
  async (templateId: number) => {
    const { data } = await photosApi.getByTemplate(templateId);
    return data;
  }
);

export const addPhoto = createAsyncThunk(
  "photos/add",
  async (payload: {
    templateId: number;
    url: string;
    description?: string;
    position?: string;
    questionTxt?: string;
  }) => {
    const { data } = await photosApi.create(payload);
    return data;
  }
);

export const updatePhoto = createAsyncThunk(
  "photos/update",
  async (payload: { id: number; data: Partial<Photo> }) => {
    const { data } = await photosApi.update(payload.id, payload.data);
    return data;
  }
);

export const deletePhoto = createAsyncThunk(
  "photos/delete",
  async (id: number) => {
    await photosApi.remove(id);
    return id;
  }
);

export const photosSlice = createSlice({
  name: "photos",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPhotos.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPhotos.fulfilled, (state, action) => {
        state.photos = action.payload.reduce(
          (acc, photo) => ({ ...acc, [photo.id]: photo }),
          {}
        );
        state.loading = false;
      })
      .addCase(addPhoto.fulfilled, (state, action) => {
        state.photos[action.payload.id] = action.payload;
      })
      .addCase(updatePhoto.fulfilled, (state, action) => {
        state.photos[action.payload.id] = action.payload;
      })
      .addCase(deletePhoto.fulfilled, (state, action) => {
        delete state.photos[action.payload];
      });
  },
});
